// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__cTD2o","active":"NavItem_active__vZuzF"};